/** Timing knobs for the onboarding chat — overridable so tests don't wait for real dwell times. */
export interface OnboardingChatTiming {
	richWaitMs?: number;
	hintWaitMs?: number;
	pollIntervalMs?: number;
	beatMs?: number;
	/** How long to wait for the list recommendation before pitching generically. */
	recommendationWaitMs?: number;
}

export const DEFAULT_TIMING: Required<OnboardingChatTiming> = {
	richWaitMs: 8000,
	hintWaitMs: 120000,
	pollIntervalMs: 2500,
	beatMs: 900,
	recommendationWaitMs: 20000,
};

/** Timing knobs for the pre-checkout priming chat (PREC-3712). */
export interface OnboardingPrimingTiming {
	/** How long to wait for the pre-warmed drafts before asking openly instead. */
	draftWaitMs?: number;
	pollIntervalMs?: number;
	beatMs?: number;
}

export const DEFAULT_PRIMING_TIMING: Required<OnboardingPrimingTiming> = {
	draftWaitMs: 90000,
	pollIntervalMs: 2500,
	beatMs: 900,
};

export const sleep = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));
